import { alpha } from '@mui/material/styles';

/**
 * Shared DataGrid chrome.
 *
 * This deliberately lives in the page-level `sx` rather than in
 * `theme.components.MuiDataGrid.styleOverrides` — routing it through the theme
 * override slot broke the virtualiser's row layout (rows rendered clipped or
 * not at all). Spread it into each grid's `sx` and add layout props separately:
 *
 *   <DataGridPro sx={{ ...dataGridSx(theme), height: '100%' }} />
 */
export const dataGridSx = (theme) => {
    const { palette } = theme;
    const isDark = palette.mode === 'dark';

    return {
        border: 'none',
        boxShadow: isDark
            ? '0 1px 5px rgba(0,0,0,0.35)'
            : '0 1px 5px rgba(0,0,0,0.05)',
        borderRadius: 2,
        backgroundColor: palette.background.paper,
        color: palette.text.primary,
        '& .MuiDataGrid-main': {
            borderRadius: 2,
            overflow: 'hidden',
        },
        '& .MuiDataGrid-columnHeaders': {
            backgroundColor: palette.surface.subtle,
            borderBottom: `1px solid ${palette.surface.border}`,
            height: '48px',
        },
        '& .MuiDataGrid-columnHeader': {
            backgroundColor: palette.surface.subtle,
        },
        '& .MuiDataGrid-filler': {
            backgroundColor: palette.surface.subtle,
        },
        '& .MuiDataGrid-scrollbarFiller': {
            backgroundColor: palette.surface.subtle,
        },
        '& .MuiDataGrid-columnHeaderTitle': {
            fontWeight: 600,
            fontSize: '0.875rem',
            color: palette.text.primary,
        },
        '& .MuiDataGrid-cell': {
            borderBottom: `1px solid ${palette.surface.border}`,
            padding: '8px 16px',
        },
        '& .MuiDataGrid-row:nth-of-type(even)': {
            backgroundColor: palette.surface.sunken,
        },
        '& .MuiDataGrid-row:hover, & .MuiDataGrid-row:nth-of-type(even):hover': {
            backgroundColor: alpha(palette.primary.main, isDark ? 0.14 : 0.06),
        },
        '& .MuiDataGrid-footerContainer': {
            borderTop: `1px solid ${palette.surface.border}`,
            backgroundColor: palette.surface.subtle,
        },
    };
};

export default dataGridSx;
